import { apiClient, apiProvider } from './utilities/Provider';

const verifyToken = async (token, mode = 'activation') => {
    const path = mode === 'reset'
        ? `/agency/activation/verify-reset/${token}`
        : `/agency/activation/verify/${token}`;
    const response = await apiClient.get(path);
    return response.data;
};

const setPassword = (token, password) =>
    apiProvider.post('agency/activation/set-password', { token, password });

const confirmPasswordReset = (token, password) =>
    apiProvider.post('agency/activation/password-reset/confirm', { token, password });

const requestPasswordReset = (email) =>
    apiProvider.post('agency/activation/password-reset/request', { email });

const ActivationService = { verifyToken, setPassword, confirmPasswordReset, requestPasswordReset };

export default ActivationService;
